export const REQUIRED_FIRST_NAME = 'First Name is required';
export const REQUIRED_LAST_NAME = 'Last Name is required';
export const REQUIRED_EMAIL = 'Email address is required';

export const INVALID_DATE_FORMAT = 'Invalid date format (MM/DD/YYYY)';
export const MIN_AGE_CONSTRAINT = 'Employee must be at least 14 years old';
export const INVALID_EMAIL = 'Wrong or invalid e-mail entered into the field';
export const FUTURE_REGISTRATION_DATE = 'Date should not exceed 14 days into the future';
export const FUTURE_OPEN_ACCOUNT_DATE = 'Date can not be in the future';
export const INVALID_PHONE_NUMBER = 'Invalid phone number';
